import React from 'react';
import { Loader, useToasts } from 'freemium-ui';
import { useGetAccountInfo, useLogin } from '../../../shared/hooks';
import { Center } from '../../../shared/styles';

const FreshidSSOSuccess = () => {
  const [isLoginSuccess, setIsLoginSuccess] = React.useState(false);
  const [, setToast] = useToasts();

  const { refetch } = useGetAccountInfo({
    enabled: isLoginSuccess,
    callback: (success: boolean) => {
      if (success) {
        window.location.href = `${window.location.origin}/app/survey`;
      }
    },
  });

  const { mutate: login } = useLogin({
    setToast,
    callback: (success: boolean, response: any) => {
      if (success) {
        if (response.non_field_errors) {
          return;
        }
        if (response.refreshToken) {
          localStorage.setItem('rfToken', response.refreshToken);
        }
        if (response.token) {
          localStorage.setItem('authToken', response.token);
          setIsLoginSuccess(true);
        }
        if (response.redirect_url) {
          window.location = response.redirect_url;
        }
      }
    },
  });

  React.useEffect(() => {
    if (isLoginSuccess) refetch();
  }, [isLoginSuccess]);

  React.useEffect(() => {
    const location = new URL(window.location.href);
    const code: any = location.searchParams.get('code');
    const sessionState = location.searchParams.get('session_state');
    const sessionToken = location.searchParams.get('session_token');
    if (sessionState)
      window.localStorage.setItem('freshid-session-state', sessionState);
    if (sessionToken)
      window.localStorage.setItem('freshid-session-token', sessionToken);
    if (code) {
      login({
        code,
        domain: window.location.host,
      });
    }
  }, []);

  return (
    <Center>
      <Loader />
    </Center>
  );
};

export default FreshidSSOSuccess;
